import {
  Scorecard,
  ScorecardCompute,
  ScorecardMultiScoreRowResultArgs,
  ScorecardReport,
  ScorecardRowResultArgs,
} from "types";

import API from "api/client";
import { envConfig } from "config";

const { scoreTablesAPI } = envConfig;

const getScoreTable = async (uuid: string): Promise<Scorecard> => {
  return API.get<Scorecard>(`${scoreTablesAPI}${uuid}/definition`).then((res) => res.data);
};

const getScoreTableMultiScoreRowResults = async (options: ScorecardMultiScoreRowResultArgs): Promise<number[]> => {
  const { uuid, scoreId } = options;
  return API.get<number[]>(`${scoreTablesAPI}${uuid}/results/multiscore-row`, { params: { scoreId } }).then(
    (res) => res.data,
  );
};

const getScoreTableRowResults = async (options: ScorecardRowResultArgs): Promise<number[]> => {
  const { uuid, questionId, scoreUri } = options;
  return API.get<number[]>(`${scoreTablesAPI}${uuid}/results/row`, {
    params: {
      questionId,
      scoreUri,
    },
  }).then((res) => res.data);
};

const getScoreTableDownloadResults = async (uuid: string): Promise<ScorecardReport[]> => {
  return API.get<ScorecardReport[]>(`${scoreTablesAPI}${uuid}/reports`).then((res) => res.data);
};

const getScoreTableDownload = async (uuid: string, reportId: string, reportType: string): Promise<string> => {
  return API.get<string>(`${scoreTablesAPI}${uuid}/reports/${reportId}/${reportType}`).then((res) => res.data);
};

const computeScoreTable = async (uuid: string): Promise<ScorecardCompute> => {
  return API.post<ScorecardCompute>(`${scoreTablesAPI}${uuid}/compute`).then((res) => res.data);
};

const createScorecard = async (data: Scorecard): Promise<Scorecard> => {
  return API.post<Scorecard>(scoreTablesAPI, data).then((res) => res.data);
};

const updateScorecard = async (data: Scorecard): Promise<Scorecard> => {
  return API.put<Scorecard>(`${scoreTablesAPI}${data.uuid}`, data).then((res) => res.data);
};

const deleteScorecard = async (uuid: string): Promise<void> => {
  return API.delete(`${scoreTablesAPI}${uuid}`).then((res) => res.data);
};

export default {
  multiScoreRowResults: getScoreTableMultiScoreRowResults,
  rowResults: getScoreTableRowResults,
  get: getScoreTable,
  getDownloads: getScoreTableDownloadResults,
  download: getScoreTableDownload,
  compute: computeScoreTable,
  create: createScorecard,
  update: updateScorecard,
  delete: deleteScorecard,
};
